export const zhanden = {
    zh: {
        banner: {
            title: '鳳凰衛視“發現新主播”粵港澳大灣區專場招募行動開啓。',
            post: 'https://x0.ifengimg.com/ucms/2024_38/2354A361087F75AC3CD41D1675BC18AC86ABC9A8_size1746_w750_h1524.png',
            info: 'https://x0.ifengimg.com/ucms/2024_39/75B26548C2DED9940A0A7562F0A304BB32A3CCCB_size69_w670_h380.png'
        },
        name: {
            title: '姓名',
            waring1: '請輸入姓名',
            waring2: '已超過最大字數',
        },
        gender: {
            title: '性別',
            man: '男',
            woman: '女',
            selectDefault: '未選擇',
            cancelText: '取消',
            confirmText: '確定',
            waring1: '請選擇性別'
        },
        age: {
            title: '年齡',
            waring1: '請輸入年齡',
            waring2: '請輸入數字',
            waring3: '最大兩位數',
        },
        education: {
            title: '教育程度',
            waring1: '請輸入教育程度',
            waring2: '已超過最大字數',
        },
        country: {
            title: '國家或地區',
            waring1: '請輸入教育程度',
            waring2: '已超過最大字數',
        },
        documents: {
            title: '所持證件',
            hkid: '香港身份證',
            Passport: '護照',
            work: '工作簽證',
            other: '其它',
            placeholder: '香港居民身份證/護照/工作簽證',
            waring1: '請選擇所持證件',
            waring2: '已超過最大字數',
        },
        hasChinese: {
            title: '熟悉語言',
            placeholder: '可填寫多種語言，如粵語、普通話、英語、……',
            waring1: '請輸入熟悉語言',
        },
        contact: {
            title: '聯絡方式',
            placeholder: '電子郵件/電話/whats/wechat',
            waring1: '請輸入聯繫方式',
            waring2: '已超過最大字數',
        },
        photo: {
            title: '形象照片',
            placeholder: '參選者之半身、全身近照各一張,必須為近期所拍攝，圖片為jpeg、png、gif、jpg類型。',
            reLoadText: '重新上傳',
            defaultImage: 'https://x0.ifengimg.com/ucms/2024_38/D0B328BF7E1A7F9AB923C473E78DA7B40AF15184_size5_w270_h270.png',
            waring1: '圖片文件已超過20MB',
            waring2: '僅支持jpeg、png、gif、jpg文件上傳',
            waring3: '請上傳照片'
        },
        videoSelf: {
            title: '自我介紹視頻',
            placeholder: '請確保視頻在1分鐘以內、不使用視頻特效，視頻為mp4、mov、quicktime類型。',
            buttonText: '上傳視頻',
            uploadText: '上傳中',
            uploadDoneText: '已上傳，點擊替換',
            waring1: '視頻文件已超過500M',
            waring2: '請上傳視頻',
        },
        videoProduct: {
            title: '視頻作品',
            placeholder: '作品必須有本人出鏡、且不使用視頻特效，時長在3分鐘內。視頻為mp4、mov、quicktime類型。',
            buttonText: '上傳視頻',
            uploadText: '上傳中',
            uploadDoneText: '已上傳，點擊替換',
            waring1: '視頻文件已超過500M',
            waring2: '請上傳視頻',
        },
        optionalInfo: {
            title: '選填信息',
        },
        introduce: {
            title: '請介紹一下自己',
            waring1: '最大1000個字符',
        },
        occupation: {
            title: '現職',
            placeholder: '如果是在校學生，請填寫學校名稱及年級',
            waring1: '已超過最大字數',
        },
        city: {
            title: '目前所在城市',
            waring1: '已超過最大字數',
        },
        about: {
            title: '社交網絡聯絡方法(如有)',
            placeholder: 'YouTube/Facbook/Instagram/x等ID或連結',
            waring1: '最大300個字符',
        },
        declaration: {
            title: '本人已細閱本報名表格的條款和條文，並同意受其約束。本人報名提供之各項資料，俱屬真實。（報名法律條款）',
            moreText: '點擊查看條文',
            detailText: '《發現新主播》是鳳凰衛視選拔、儲備優秀國際傳播人才的一檔大型活動，由鳳凰衛視委託北京鳳凰匯播傳媒有限公司（以下簡稱“鳳凰匯播”）拍攝製作成為專題節目，用作鳳凰衛視及旗下自有頻道及合作的第三方平台播出。<br />該節目由鳳凰新媒體有限公司之附屬公司北京天盈九州網絡技術有限公司運營的鳳凰網（www.ifeng.com）（“鳳凰新媒體/鳳凰網”）為你提供【發現新主播】平台，作為上傳報名資訊及其他資料的唯一官方入口。<br />為了更好地保護你的權益，請務必審慎閱讀、充分理解以下內容及授權。如你不同意以下內容或其中任何條款，你應立即停止使用【發現新主播】平台。 你點擊“同意”，則視為你已閱讀並同意以下內容及授權，將在你與北京天盈九州網絡技術有限公司之間產生法律效力。<br />1、節目完成片及一切素材的智慧財產權屬於鳳凰衛視或鳳凰匯播所有，承諾人同意不以任何形式主張對節目的版權及收益權。<br />2.承諾人確認鳳凰衛視對節目擁有最終審核權，有權決定在鳳凰衛視所屬頻道以及其他自有頻道（包括但不限於鳳凰秀、鳳凰網以及鳳凰衛視和附屬機構在社交媒體註冊的賬號上）和第三方平台（包括但不限於全球範圍內的電視媒體、網路媒體、社交媒體、自媒體）播出並獲取收益。<br />3.承諾人同意鳳凰衛視及鳳凰匯播在本節目中使用本人的肖像，同意鳳凰衛視在第2條所述範圍對節目進行宣傳和播映時使用本人肖像。<br />4.承諾人同意嚴格保守保密資訊（包括但不限於節目資料、尚未公開的節目創作、方案策劃，樣片，文稿，素材，影像及圖片等）。<br />5.承諾人提交給鳳凰衛視參與本次活動選拔的影片內容，需確保其真實、合法性。並確保影片內容中涉及的主要出鏡人同意鳳凰衛視及其自有頻道平台使用其肖像，並確保所提供的節目影片內容，包括但不限於拍攝人物、場景、畫面、配音、音樂和其他的音影片資料等均已獲得權利人的許可或授權。承諾人同意鳳凰衛視可以在第2條所述管道為節目播出、活動宣傳及節目推廣需要使用該等影片。由於承諾人提交的影片內容瑕疵引發的爭議由承諾人負責。<br />6.承諾人同意在參與節目拍攝製作過程中，因自身原因發生人身意外損傷或財產損失，與鳳凰衛視及北京鳳凰匯播傳媒有限公司無涉。<br />7.承諾人在參與節目製作過程中，不得以鳳凰衛視的名義進行任何形式的招商和行銷活動，亦不得做出有損鳳凰衛視及鳳凰匯播公司名譽的行為。<br />8、以上承諾條款，若承諾人違反，鳳凰衛視及鳳凰匯播公司均有權向承諾人追究法律責任。<br />',
            agreeText: '同意',
            disagreeText: '不同意'
        },
        button: {
            submit: 'https://x0.ifengimg.com/ucms/2024_38/068056ECBEF7924A8665BF379448E5C08BFF9099_size5_w306_h92.png',
            save: 'https://x0.ifengimg.com/ucms/2024_29/FDD0B60DF960924A028EEFD71A278A72EB67755D_size4_w306_h92.png'
        },
        confirm: {
            title1: '確認提交報名資料嗎？',
            title2: '確認更新報名資料嗎？',
            confirmText: '確認',
            checkIt: '再檢查一下'
        },
        success: {
            title1: '我們已經收到你的資料啦！<br />我們會盡快查看並聯絡你。',
            title2: '我們已經收到你的更新資料啦！<br />我們會盡快查看並聯絡你。',
            info: '問題回饋',
        },
        api: {
            waring1: '未知錯誤，提交失敗，請稍後重試',
            waring2: '請確認報名條約'
        },
        save: {
            title: '保存成功'
        },
        share: {
            title: '鳳凰衛視“發現新主播”粵港澳大灣區專場招募行動開啓。',
            img: 'https://d.ifengimg.com/w300_h300_q90/x0.ifengimg.com/ucms/2024_29/7533C3861CF9F2DE9724A9783FEE0F0D271A4264_size1572_w1080_h1080.png',
            desc: '想成為鳳凰衛視主持人、主播、出鏡記者就快來報名參加吧！'
        }
    },
    en: {
        banner: {
            title: 'Phoenix satellite TV\'s "Host Hunt" recruitment campaign in Greater Bay Area has begun',
            post: 'https://x0.ifengimg.com/ucms/2024_38/2354A361087F75AC3CD41D1675BC18AC86ABC9A8_size1746_w750_h1524.png',
            info: 'https://x0.ifengimg.com/ucms/2024_39/95E6DC051FD3B4E4E515E333008627BA50958287_size94_w670_h536.png'
        },
        name: {
            title: 'Name',
            waring1: 'Please enter your name.',
            waring2: 'Exceeds maximum character limit',
        },
        gender: {
            title: 'Gender',
            man: 'Male',
            woman: 'Female',
            selectDefault: 'Unselected',
            cancelText: 'cancel',
            confirmText: 'confirm',
            waring1: 'Please select gender.'
        },
        age: {
            title: 'Age',
            waring1: 'Please enter age.',
            waring2: 'Please enter a number.',
            waring3: 'Maximum two digits.',
        },
        education: {
            title: 'Education level',
            waring1: 'Please enter educational level.',
            waring2: 'Exceeds maximum character limit.',
        },
        country: {
            title: 'Country or Region',
            waring1: 'Please enter country or region.',
            waring2: 'Exceeds maximum character limit.',
        },
        documents: {
            title: 'Document type',
            hkid: 'Hong Kong I.D.card',
            Passport: 'Passport',
            work: 'Working Visa',
            other: 'Others',
            placeholder: 'Hong Kong Resident Identity Card /passport/ Work visa',
            waring1: 'Please select document type.',
            waring2: 'Exceeds maximum character limit.',
        },
        hasChinese: {
            title: 'Familiarity with language',
            // eslint-disable-next-line no-useless-escape
            placeholder: 'Multiple languages can be filled in，e.g.Cantonese、Mandarin、English、……',
            waring1: 'Please enter familiarity with language',
        },
        contact: {
            title: 'Contact Information',
            placeholder: 'Email/Phone/WhatsApp/WeChat',
            waring1: 'Please enter contact information.',
            waring2: 'Exceeds maximum character limit.',
        },
        photo: {
            title: 'Profile Photo',
            placeholder: 'One clear half-body and one full-body photo, images only support jpeg, png, gif, jpg formats.',
            reLoadText: 'Upload Again',
            defaultImage: 'https://x0.ifengimg.com/ucms/2024_36/9F25FE83CDA926E257116BCBA31AFC74A3811F02_size8_w270_h270.png',
            waring1: 'Image file exceeds 20MB',
            waring2: 'Image upload only supports jpeg, png, gif, jpg files',
            waring3: 'Please uploaded a photo'
        },
        videoSelf: {
            title: 'Self-Introduction Video',
            placeholder: 'Please ensure the video is under 1 minute, does not use beauty filters, and does not use any filters. Video only supports mp4, mov, quicktime formats.',
            buttonText: 'Upload Video',
            uploadText: 'Uploading',
            uploadDoneText: 'Uploaded. Click to replace.',
            waring1: 'The video file has exceeded 500MB',
            waring2: 'Please upload a video.',
        },
        videoProduct: {
            title: 'Video Works',
            placeholder: 'Please upload a video of yourself on screen, without beauty filters, without music, with an environment, with a theme, focusing on movement, within 3 minutes.Video only supports mp4, mov, quicktime formats.',
            buttonText: 'Upload Video',
            uploadText: 'Uploading',
            uploadDoneText: 'Uploaded. Click to replace.',
            waring1: 'The video file has exceeded 500MB',
            waring2: 'Please upload a video.',
        },
        optionalInfo: {
            title: 'Optional Information',
        },
        introduce: {
            title: 'Introduce Yourself',
            waring1: 'Maximum 1000 characters.',
        },
        occupation: {
            title: 'Current occupation',
            placeholder: 'If you are a currently a student, please fill in the school name and year',
            waring1: 'Exceeds maximum character limit.',
        },
        city: {
            title: 'Current city',
            waring1: 'Exceeds maximum character limit.',
        },
        about: {
            title: 'Social Network Details(if any)',
            placeholder: 'ID or link to YouTube/Facebook/Instagram/x/……',
            waring1: 'Maximum 300 characters.',
        },
        declaration: {
            title: 'I am responsible for the authenticity of the above registration information and content and am aware of the relevant legal regulations.',
            moreText: 'Click to view details.',
            detailText: '"Host Hunt" is a large-scale event organized by Phoenix satellite TV to select and cultivate outstanding international communication talents. It is produced by Beijing Phoenix Huibo Media Co.,Ltd. hereinafter referred to as " Beijing Phoenix Huibo Media ") and will be broadcast as a special program on Phoenix satellite TV and its affiliated channels and partnered third-party platforms.<br />The program provides the "Host Hunt" platform through Phoenix New Media\'s subsidiary,Beijing Tianying Jiuzhou Network Technology Co.,Ltd,operating iFeng (www.ifeng.com) (referred to as "Phoenix New Media/iFeng") as the sole official entry for uploading registration information and other materials.<br />To better protect your rights,please carefully read and fully understand the following content and authorization. If you do not agree with the following content or any of its clauses,you should immediately cease using the "Host hunt" platform. By clicking "Agree," you indicate that you have read and agree to the following content and authorization,which will have legal effect between you and Beijing Tianying Jiuzhou Network Technology Co.,Ltd.<br />The intellectual property rights of the completed program and all materials belong to Phoenix satellite TV or Beijing Phoenix Huibo Media Co.,Ltd.,and the signatory agrees not to claim any copyright or profit rights to the program in any form.<br />The signatory confirms that Phoenix satellite TV has the final review rights over the program and has the right to decide how the program is broadcast and monetized on Phoenix satellite TV’s channels and other proprietary channels (including but not limited to Phoenix Show,Phoenix Network,and social media accounts registered by Phoenix satellite TV and its affiliates) and third-party platforms (including but not limited to television media,online media,social media,and self-media globally).<br />The signatory agrees to allow Phoenix satellite TV and Beijing Phoenix Huibo Media Co.,Ltd.to use their likeness in the program and for promotional and broadcasting purposes as described in Clause 2.<br />The signatory agrees to strictly maintain the confidentiality of sensitive information (including but not limited to program materials,unpublished program concepts,drafts,scripts,footage,images,etc.).<br />The video content submitted by the signatory for participation in this selection must ensure its authenticity and legality. The signatory must ensure that the main individuals appearing in the video consent to the use of their likeness by Phoenix satellite TV and its proprietary channel platforms,and that all content provided,including but not limited to filmed individuals,scenes,footage,voiceovers,music,and other audiovisual materials,has been authorized by the rights holders. The signatory agrees that Phoenix satellite TV may use such footage for broadcasting,event promotion,and program marketing as described in Clause 2. Any disputes arising from defects in the submitted footage will be the responsibility of the signatory.<br />The signatory agrees that any personal injury or property loss incurred during the filming and production process due to their own reasons will not involve Phoenix satellite TV or Beijing Phoenix Huibo Media Co.,Ltd.<br />The signatory shall not engage in any form of marketing or promotional activities on behalf of Phoenix satellite TV during the production process,nor shall they engage in any actions that could harm the reputation of Phoenix satellite TV or and Beijing Phoenix Huibo Media Co.,Ltd..<br />If the signatory violates any of the above commitments,both Phoenix satellite TV and and Beijing Phoenix Huibo Media Co.,Ltd.have the right to pursue legal responsibility against the signatory.',
            agreeText: 'Agree',
            disagreeText: 'Disagree'
        },
        button: {
            submit: 'https://x0.ifengimg.com/ucms/2024_36/2C649CE4D78A71D48F6466D33022144D15F9BF30_size5_w306_h92.png',
            save: 'https://x0.ifengimg.com/ucms/2024_36/AD40FCA880800524C8963B9CAD713A1CA08E581B_size5_w306_h92.png'
        },
        confirm: {
            title1: 'Do you confirm the submission of your registration information?',
            title2: 'Do you confirm the submission of your updated registration information?',
            confirmText: 'Confirm',
            checkIt: 'Check again'
        },
        success: {
            title1: 'We have received your information! <br />We will review it and contact you as soon as possible.',
            title2: 'We have received your updated information!<br />We will review it and contact you as soon as possible.',
            info: 'Feedback Email',
        },
        api: {
            waring1: 'Unknown error, submission failed. Please try again later.',
            waring2: 'Please check to acknowledge the information'
        },
        save: {
            title: 'Saved'
        },
        share: {
            title: 'Phoenix satellite TV\'s "Host Hunt" recruitment campaign in Greater Bay Area has begun',
            img: 'https://d.ifengimg.com/w300_h300_q90/x0.ifengimg.com/ucms/2024_29/7533C3861CF9F2DE9724A9783FEE0F0D271A4264_size1572_w1080_h1080.png',
            desc: 'Want to become a presenter, anchor, or on-screen reporter for Phoenix TV? Sign up to participate now!'
        }
    },
    ch: {
        banner: {
            title: '凤凰卫视“发现新主播”粤港澳大湾区专场招募行动开启',
            post: 'https://x0.ifengimg.com/ucms/2024_38/2354A361087F75AC3CD41D1675BC18AC86ABC9A8_size1746_w750_h1524.png',
            info: 'https://x0.ifengimg.com/ucms/2024_39/A0E2B33E212C155A0153AF761FE89DE5456EBADF_size65_w670_h380.png'
        },
        name: {
            title: '姓名',
            waring1: '请输入姓名',
            waring2: '已超过最大字数',
        },
        gender: {
            title: '性別',
            man: '男',
            woman: '女',
            selectDefault: '未选择',
            cancelText: '取消',
            confirmText: '确定',
            waring1: '请选择性别'
        },
        age: {
            title: '年龄',
            waring1: '请输入年龄',
            waring2: '请输入数字',
            waring3: '最大两位数',
        },
        education: {
            title: '教育程度',
            waring1: '请输入教育程度',
            waring2: '已超过最大字数',
        },
        country: {
            title: '国家或地区',
            waring1: '请输入教育程度',
            waring2: '已超过最大字数',
        },
        documents: {
            title: '所持证件',
            hkid: '香港身份证',
            Passport: '护照',
            work: '工作签证',
            other: '其它',
            placeholder: '香港居民身份证/护照/工作签证',
            waring1: '请输入所持证件',
            waring2: '已超过最大字数',
        },
        hasChinese: {
            title: '熟悉语言',
            placeholder: '可填写多种语言，如粤语、普通话、英语、……',
            waring1: '请输入熟悉语言',
        },
        contact: {
            title: '联络方式',
            placeholder: '电子邮件/电话/whats/wechat',
            waring1: '请输入联系方式',
            waring2: '已超过最大字数',
        },
        photo: {
            title: '形象照片',
            placeholder: '参选者之半身、全身近照各一张，必须为近期所拍摄，图片为jpeg、png、gif、jpg类型。',
            reLoadText: '重新上传',
            defaultImage: 'https://x0.ifengimg.com/ucms/2024_38/D0B328BF7E1A7F9AB923C473E78DA7B40AF15184_size5_w270_h270.png',
            waring1: '图片文件已超过20MB',
            waring2: '仅支持jpeg、png、gif、jpg文件上传',
            waring3: '请上传照片'
        },
        videoSelf: {
            title: '自我介绍视频',
            placeholder: '请确保视频在1分钟以内、不适用视频特效，视频为mp4、mov、quicktime类型。',
            buttonText: '上传视频',
            uploadText: '上传中',
            uploadDoneText: '已上传，点击替换',
            waring1: '视频文件已超过500M',
            waring2: '请上传视频',
        },
        videoProduct: {
            title: '视频作品',
            placeholder: '作品必须有本人出镜、且不使用视频特效，视频为mp4、mov、quicktime类型。',
            buttonText: '上传视频',
            uploadText: '上传中',
            uploadDoneText: '已上传，点击替换',
            waring1: '视频文件已超过500M',
            waring2: '请上传视频',
        },
        optionalInfo: {
            title: '选填信息',
        },
        introduce: {
            title: '请介绍一下自己',
            waring1: '最大1000个字符',
        },
        occupation: {
            title: '现职',
            placeholder: '如果在校学生，请填写学校名称及年级',
            waring1: '最超过最大字数',
        },
        city: {
            title: '目前所在城市',
            waring1: '已超过最大字数',
        },
        about: {
            title: '社交网络联系方式(如有)',
            placeholder: 'YouTube/Facbook/Instagram/x等ID或链接',
            waring1: '最大300个字符',
        },
        declaration: {
            title: '本人已细阅本报名表格的条款和条文，并同意受其约束。本人报名提供之各项资料，具属真实。（报名法律条款）',
            moreText: '点击查看条文',
            detailText: '《发现新主播》是凤凰卫视选拔、储备优秀国际传播人才的一档大型活动，由凤凰卫视委託北京凤凰汇播传媒有限公司（以下简称“凤凰汇播”）拍摄制作成为专题节目，用作凤凰卫视及旗下自有频道及合作的第三方平台播出。<br />该节目由凤凰新媒体有限公司之附属公司北京天盈九州网络技术有限公司运营的凤凰网（www.ifeng.com）（“凤凰新媒体/凤凰网”）为你提供【发现新主播】平台，作为上传报名资讯及其他资料的唯一官方入口。<br />为了更好地保护你的权益，请务必审慎阅读、充分理解以下内容及授权。如你不同意以下内容或其中任何条款，你应立即停止使用【发现新主播】平台。 你点击“同意”，则视为你已阅读并同意以下内容及授权，将在你与北京天盈九州网络技术有限公司之间产生法律效力。<br />1、节目完成片及一切素材的智慧财产权属于凤凰卫视或凤凰汇播所有，承诺人同意不以任何形式主张对节目的版权及收益权。<br />2.承诺人确认凤凰卫视对节目拥有最终审核权，有权决定在凤凰卫视所属频道以及其他自有频道（包括但不限于凤凰秀、凤凰网以及凤凰卫视和附属机构在社交媒体注册的账号上）和第三方平台（包括但不限于全球范围内的电视媒体、网路媒体、社交媒体、自媒体）播出并获取收益。<br />3.承诺人同意凤凰卫视及凤凰汇播在本节目中使用本人的肖像，同意凤凰卫视在第2条所述范围对节目进行宣传和播映时使用本人肖像。<br />4.承诺人同意严格保守保密资讯（包括但不限于节目资料、尚未公开的节目创作、方案策划，样片，文稿，素材，影像及图片等）。<br />5.承诺人提交给凤凰卫视参与本次活动选拔的影片内容，需确保其真实、合法性。并确保影片内容中涉及的主要出镜人同意凤凰卫视及其自有频道平台使用其肖像，并确保所提供的节目影片内容，包括但不限于拍摄人物、场景、画面、配音、音乐和其他的音影片资料等均已获得权利人的许可或授权。承诺人同意凤凰卫视可以在第2条所述管道为节目播出、活动宣传及节目推广需要使用该等影片。由于承诺人提交的影片内容瑕疵引发的争议由承诺人负责。<br />6.承诺人同意在参与节目拍摄制作过程中，因自身原因发生人身意外损伤或财产损失，与凤凰卫视及北京凤凰汇播传媒有限公司无涉。<br />7.承诺人在参与节目制作过程中，不得以凤凰卫视的名义进行任何形式的招商和行销活动，亦不得做出有损凤凰卫视及凤凰汇播公司名誉的行为。<br />8、以上承诺条款，若承诺人违反，凤凰卫视及凤凰汇播公司均有权向承诺人追究法律责任。<br />',
            agreeText: '同意',
            disagreeText: '不同意'
        },
        button: {
            submit: 'https://x0.ifengimg.com/ucms/2024_38/068056ECBEF7924A8665BF379448E5C08BFF9099_size5_w306_h92.png',
            save: 'https://x0.ifengimg.com/ucms/2024_39/701B640458A479F77F573A4F9B779438CB48C596_size4_w306_h92.png'
        },
        confirm: {
            title1: '确认提交报名资料吗？',
            title2: '确认更新报名资料吗？',
            confirmText: '确认',
            checkIt: '再检查一下'
        },
        success: {
            title1: '我们已经收到你的资料啦！<br />我们会尽快查看并联络你。',
            title2: '我们已经收到你的更新资料啦！<br />我们会尽快查看并联络你。',
            info: '问题回馈',
        },
        api: {
            waring1: '未知错误，提交失败，请稍后重试',
            waring2: '请确认报名条约'
        },
        save: {
            title: '保存成功'
        },
        share: {
            title: '凤凰卫视“发现新主播”粤港澳专场招募行动开啓。',
            img: 'https://d.ifengimg.com/w300_h300_q90/x0.ifengimg.com/ucms/2024_29/7533C3861CF9F2DE9724A9783FEE0F0D271A4264_size1572_w1080_h1080.png',
            desc: '想成为凤凰卫视主持人、主播、出镜记者就快来报名参加吧！'
        }
    }
};
